const cssUrl = `${import.meta.env.VITE_CDN_ROOT}${import.meta.env.VITE_ASCEND_AWESOME_VERSION}/css/trustage-aa--wc.css`

const t = document.createElement('template')
t.innerHTML = `
<link href="${cssUrl}" rel="stylesheet" />
<style>
.ascend-footer {
  /* debug border */
  /* border: solid 1px black; */

  font-family: 'Sul Sans';
  padding: var(--wa-spacing-2xl, 40px), 0;
  border-bottom: 8px solid var(--wa-color-trustage-yellow, #fae07e);
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.ascend-footer__container__border__top {
  border-top: 1px solid #f2f2f2;
  margin-top: var(--wa-spacing-2xl, 40px);
  margin-bottom: var(--wa-spacing-2xl, 40px);
}

.ascend-footer__container {
  /* debug border */
  /*border: solid 1px lightgrey;*/

  max-width: var(--ts-breakpoint-xxl-min);
  padding: 0 var(--wa-spacing-m, 16px);
}

.ascend-footer__list {
  /* debug border */
  /* border: dashed 1px lightgrey; */
  margin: 0;
  list-style: none;
  padding-left: 0;
  display: flex;
  flex-direction: column;
  gap: var(--wa-spacing-l, 24px);
}

.ascend-footer__item {
  font-size: 14px;
}

.ascend-footer__link {
  color: var(--wa-color-neutral-10, #171717);
  text-decoration: none;
  border-bottom: 0;
}

.ascend-footer__link::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: -2px;
  width: 100%;
  height: 2px;
  background-color: currentColor;
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.3s ease;
}

.ascend-footer__link:hover {
  color: var(--wa-color-neutral-10, #171717);
}

.ascend-footer__link:hover::after {
  transform: scaleX(1);
}

.ascend-footer__copyright {
  margin-top: var(--wa-spacing-2xl, 40px);
  margin-bottom: var(--wa-spacing-2xl, 40px);

  color: var(--wa-color-neutral-40, #525252);
  font-size: 14px;
  font-weight: 400;
}

/* XS */
@media only screen and (max-width: 575px) {
  /* default */
}

/* S */
@media only screen and (min-width: 576px) {
  .ascend-footer {
    min-width: var(--ts-breakpoint-sm-min, 576px);
  }
  .ascend-footer__list {
    flex-direction: row;
  }
}

/* M */
@media only screen and (min-width: 768px) {
  .ascend-footer__container {
    padding: 0 var(--wa-spacing-m, 16px);
  }
  .ascend-footer__list {
    gap: var(--wa-spacing-l, 24px);
  }
}

/* L */
@media only screen and (min-width: 992px) {
  .ascend-footer__container {
    padding: 0 var(--wa-spacing-l, 24px);
  }
  .ascend-footer__list {
    gap: var(--wa-spacing-2xl, 40px);
  }
}

/* XL */
@media only screen and (min-width: 1200px) {
  /* ##GENERATED-XL## */
}

/* XXL */
@media only screen and (min-width: 1440px) {
  .ascend-footer__container {
    min-width: 1440px;
    margin-inline: auto;
  }
}
</style>
`
const TemplateNavFooterBasicStyles = t
export { TemplateNavFooterBasicStyles }
